import { Pipe, PipeTransform } from '@angular/core';
import { MailParticipant, MailParticipants } from '../types';

@Pipe({
  name: 'mailParticipantFrom',
})
export class MailParticipantFromPipe implements PipeTransform {
  transform(mail: MailParticipants): MailParticipant {
    return mail.sentBy && mail.sentBy.person ? mail.sentBy : mail.from;
  }
}
